import type { AdObj, NativeAdObj, CsmAdObj } from '../../shared/types/ast';

export function isMediation(adObj: AdObj): adObj is CsmAdObj {
    return adObj.source === 'csm';
}

export function isNative(adObj: AdObj): adObj is NativeAdObj {
    return adObj && adObj.adType === 'native' && adObj.source === 'rtb';
}

export function isNativeVideoOrContent(adObj): 'video' | 'content' | '' {
    if (adObj?.native?.video && adObj?.native?.video?.content) {
        return 'video';
    }
    if (adObj?.native?.desc2) {
        return adObj.native.desc2;
    }
    if (adObj?.native?.custom) {
        return adObj.native.custom.type;
    }
    return '';
}
